module.exports = "/static/media/device-background.bee52a28.png";